import { combineReducers } from "redux";
import authReducer from "./generic/authReducer";
import screenReducer from "./generic/screenReducer";
import notifications from "./generic/notifications";
import scopeReducer from "./generic/scopeReducer";
import genericPageState from "./generic/genericPageState";
import toastReducer from "./generic/toastReducer";
import fetchingDataReducer from "./generic/fetchingDataReducer";

export default combineReducers({
  auth: authReducer,
  fetchingData: fetchingDataReducer,
  screenInfo: screenReducer,
  toastList: toastReducer,
  notifications,
  scope: scopeReducer,
  genericPageState,
});
